import React from 'react';
import { Product } from '../ProductType';

interface ProductSectionProps {
  title: string;
  products: Product[];
  isAdmin: boolean | undefined;
  editedFields: Record<string, Set<string>>;
  handleNameChange: (id: string, value: string) => void;
  handlePriceChange: (id: string, value: string) => void;
  handleBoxWeightChange: (id: string, value: string) => void;
  handleStockChange: (id: string, hasStock: boolean) => void;
  buildWeightLabel: (product: Product) => string;
}

const PriceProductSection: React.FC<ProductSectionProps> = ({
  title,
  products,
  isAdmin,
  editedFields,
  handleNameChange,
  handlePriceChange,
  handleBoxWeightChange,
  handleStockChange,
  buildWeightLabel,
}) => {
  if (products.length === 0) return null;

  return (
    <>
      <tr>
        <td className="category-title" colSpan={isAdmin ? 4 : 3}>
          {title}
        </td>
      </tr>
      {products.map((product) => (
        <tr key={product.id}>
          <td className="product-name">
            {isAdmin ? (
              <input
                type="text"
                value={product.name}
                onChange={(e) => handleNameChange(product.id, e.target.value)}
                className={`editable-input price-input ${
                  editedFields[product.id]?.has('name') ? 'input-edited' : ''
                }`}
              />
            ) : (
              product.name
            )}
          </td>
          <td>
            {isAdmin ? (
              <input
                type="text"
                value={product.boxWeight}
                onChange={(e) =>
                  handleBoxWeightChange(product.id, e.target.value)
                }
                className={`editable-input price-input ${
                  editedFields[product.id]?.has('boxWeight')
                    ? 'input-edited'
                    : ''
                }`}
              />
            ) : (
              buildWeightLabel(product)
            )}
          </td>
          <td className="product-price">
            {isAdmin ? (
              <input
                type="text"
                value={product.price}
                onChange={(e) => handlePriceChange(product.id, e.target.value)}
                className={`editable-input price-input ${
                  editedFields[product.id]?.has('price') ? 'input-edited' : ''
                }`}
              />
            ) : (
              `$${product.price}`
            )}
          </td>
          {isAdmin && (
            <td style={{ textAlign: 'center' }}>
              <input
                type="checkbox"
                checked={product.hasStock ?? true}
                onChange={(e) =>
                  handleStockChange(product.id, e.target.checked)
                }
                className={`stock-checkbox ${
                  editedFields[product.id]?.has('hasStock')
                    ? 'input-edited'
                    : ''
                }`}
                style={{ width: '18px', height: '18px', cursor: 'pointer' }}
              />
            </td>
          )}
        </tr>
      ))}
    </>
  );
};

export default PriceProductSection;
